<div class="container-fluid mt-3">
  <h3>Mail search</h3>

  <div class="row mb-2">
    <div class="col-12 col-md-6">
      <label>Free text</label>
      <input type="text" class="form-control" [(ngModel)]="freeText" (keyup.enter)="search()" placeholder="subject, from, text..." />
    </div>
    <div class="col-6 col-md-3">
      <label>Sort field</label>
      <input type="text" class="form-control" [(ngModel)]="sortField" />
    </div>
    <div class="col-6 col-md-3">
      <label>Sort order</label>
      <select class="form-control" [(ngModel)]="sortOrder">
        <option value="desc">desc</option>
        <option value="asc">asc</option>
      </select>
    </div>
  </div>

  <div class="mb-2">
    <strong>Filters</strong>
    <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="addFilter()">+ Add filter</button>
  </div>

  @for (filter of filters; track filter; let i = $index) {
    <div class="row mb-2 align-items-center">
      <div class="col-3">
        <input type="text" class="form-control" list="mail-fields" [(ngModel)]="filter.field" placeholder="field" />
        <datalist id="mail-fields">
          @for (f of fieldSuggestions; track f) {
            <option [value]="f"></option>
          }
        </datalist>
      </div>
      <div class="col-3">
        <select class="form-control" [(ngModel)]="filter.operator">
          @for (op of operators; track op) {
            <option [value]="op">{{op}}</option>
          }
        </select>
      </div>
      <div class="col-4">
        @if (needsValues(filter.operator)) {
          <input type="text" class="form-control" placeholder="comma,separated,values"
                 [ngModel]="(filter.values || []).join(', ')"
                 (ngModelChange)="setValuesFromCsv(filter, $event)" />
        } @else if (needsValue(filter.operator)) {
          <input type="text" class="form-control" placeholder="value" [(ngModel)]="filter.value" />
        }
      </div>
      <div class="col-2">
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFilter(i)">Remove</button>
      </div>
    </div>
  }

  @if (folders.length > 0) {
    <div class="mb-2">
      <small class="text-muted">Folders: </small>
      @for (folder of folders; track folder.folder) {
        <span class="badge bg-secondary me-1 cursor-pointer" (click)="freeText = ''; addFilter(); filters[filters.length - 1].field = 'folder'; filters[filters.length - 1].operator = 'EQUALS'; filters[filters.length - 1].value = folder.folder">
          {{folder.folder}} ({{folder.count}})
        </span>
      }
    </div>
  }

  <button type="button" class="btn btn-primary mb-3" (click)="search()" [disabled]="loading">Search</button>
  <button type="button" class="btn btn-outline-secondary mb-3 ms-2" (click)="reset()" [disabled]="loading">Reset</button>

  <div class="mb-2">
    {{hits.length}} shown / {{total}} total
  </div>

  <table class="table table-sm table-hover">
    <thead>
      <tr>
        <th>Subject</th>
        <th>From</th>
        <th>Folder</th>
        <th>Received</th>
        <th>Flags</th>
        <th>Snippet</th>
      </tr>
    </thead>
    <tbody>
      @for (hit of hits; track hit.elasticDocumentId) {
        <tr class="cursor-pointer" (click)="showDetail(hit)">
          <td class="filterable-cell">
            <span class="quick-filter-buttons">
              <button type="button" class="quick-filter-btn" title="Filter for value" [disabled]="!hit.subject" (click)="addQuickFilter('subject', hit.subject, false); $event.stopPropagation()">+</button>
              <button type="button" class="quick-filter-btn exclude" title="Filter out value" [disabled]="!hit.subject" (click)="addQuickFilter('subject', hit.subject, true); $event.stopPropagation()">&minus;</button>
            </span>
            {{hit.subject}}
          </td>
          <td class="filterable-cell">
            @let fromInfo = getFromField(hit);
            <span class="quick-filter-buttons">
              <button type="button" class="quick-filter-btn" title="Filter for value" [disabled]="!fromInfo" (click)="fromInfo && addQuickFilter(fromInfo.field, fromInfo.value, false); $event.stopPropagation()">+</button>
              <button type="button" class="quick-filter-btn exclude" title="Filter out value" [disabled]="!fromInfo" (click)="fromInfo && addQuickFilter(fromInfo.field, fromInfo.value, true); $event.stopPropagation()">&minus;</button>
            </span>
            {{hit.fromName || hit.fromEmail || hit.from}}
          </td>
          <td class="filterable-cell">
            <span class="quick-filter-buttons">
              <button type="button" class="quick-filter-btn" title="Filter for value" [disabled]="!hit.folder" (click)="addQuickFilter('folder', hit.folder, false); $event.stopPropagation()">+</button>
              <button type="button" class="quick-filter-btn exclude" title="Filter out value" [disabled]="!hit.folder" (click)="addQuickFilter('folder', hit.folder, true); $event.stopPropagation()">&minus;</button>
            </span>
            {{hit.folder}}
          </td>
          <td class="filterable-cell">
            <span class="quick-filter-buttons">
              <button type="button" class="quick-filter-btn" title="Filter for value" [disabled]="!hit.receivedDate" (click)="addQuickFilter('receivedDate', hit.receivedDate, false); $event.stopPropagation()">+</button>
              <button type="button" class="quick-filter-btn exclude" title="Filter out value" [disabled]="!hit.receivedDate" (click)="addQuickFilter('receivedDate', hit.receivedDate, true); $event.stopPropagation()">&minus;</button>
            </span>
            {{hit.receivedDate}}
          </td>
          <td>
            @for (flag of hit.flags; track flag) {
              <span class="filterable-cell filterable-chip">
                <span class="quick-filter-buttons">
                  <button type="button" class="quick-filter-btn" title="Filter for value" (click)="addQuickFilter('flags', flag, false); $event.stopPropagation()">+</button>
                  <button type="button" class="quick-filter-btn exclude" title="Filter out value" (click)="addQuickFilter('flags', flag, true); $event.stopPropagation()">&minus;</button>
                </span>
                {{flag}}
              </span>
            }
          </td>
          <td>{{hit.snippet}}</td>
        </tr>
      }
    </tbody>
  </table>

  <div class="mb-3">
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="prevPage()" [disabled]="page === 0">Prev</button>
    <span class="mx-2">page {{page + 1}}</span>
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="nextPage()" [disabled]="(page + 1) * size >= total">Next</button>
  </div>
</div>
